import React, { useState } from 'react';
import Switch from 'react-switch';
import * as api from 'utils/api';
import { adminBaseUrl } from 'resources';
import { GdprModalContainer } from '../../gdpr/gdpr-modal/gdpr-modal';

export const SdkEnabled = ({ sdkEnabled, id }) => {
  const [enabled, setEnabled] = useState(sdkEnabled);
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => setShowModal(false);

  const openModal = () =>
    setShowModal(true);

  const toggleSdkEnabled = async () => {
    try {
      const response = await api.put(`${adminBaseUrl}/organizations/${id}`, {
        sdk_enabled: !enabled,
      });

      if (response.ok) {
        setEnabled(!enabled);
        closeModal();
      } else {
        console.error('Failed to update SDK status');
        alert('Failed to update SDK status');
      }
    } catch (error) {
      console.error('Error during SDK update:', error);
      alert('Error during SDK update');
    }
  };

  const title = enabled ? 'Disable SDK for this organization?' : 'Enable SDK for this organization?';
  const body = enabled
    ? 'This will stop SDK versions 7.4 and higher from sending interactions, events, and custom data to Digital, across every app in this organization. You can turn SDK enable back on at any time to resume normal traffic.'
    : 'This will resume all interactions, events, and custom data for every application in this organization.';
  const submitLabel = enabled ? 'Disable SDK' : 'Enable SDK';

  return (
    <>
      <tr>
        <td>SDK Enabled</td>
        <td><Switch
          onChange={openModal}
          checked={enabled}
          onColor="#4ade80"
          offColor="#9ca3af"
          height={22}
          width={44}
        />
        </td>
      </tr>
      {showModal && (
        <GdprModalContainer
          title={title}
          body={body}
          submitLabel={submitLabel}
          submitHandler={toggleSdkEnabled}
          cancelHandler={closeModal}
        />
      )}
    </>

  );
};
